export default "__VITE_ASSET__BypBHHfO__"